import { lpRequest, toBoolean, toNumber } from '../../../../core/utils/lp-backend';
import { IAlertSetting } from '../../../me/domain/entities/me-entity';
import { toSettings } from '../repositories/settings-repository-impl';
import { readSettings } from './settings-fields';

/**
 * `PATCH /client/config/fields {alerts}` replaces the whole list, so the alert replaces (by `type`) or joins the
 * client's current alerts, read from `GET /client/user/me`.
 */
export const editAlertSettings = async (alert: IAlertSetting): Promise<any> => {
  const me = await lpRequest('GET', '/client/user/me');
  const alerts: IAlertSetting[] = [...(me.account?.alerts || [])];
  const entry = {
    type: alert.type,
    enabled: toBoolean(alert.enabled),
    target: toNumber(alert.target) ?? 0,
    buffer: toNumber(alert.buffer) ?? 0
  };
  const index = alerts.findIndex((stored) => stored.type === alert.type);
  if (index > -1) alerts[index] = entry;
  else alerts.push(entry);

  await lpRequest('PATCH', '/client/config/fields', { body: { alerts } });

  return toSettings(await readSettings());
};
